import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab, MessageBoxType } from '../../constants/Enums';
import { PersistentStore } from '../../stores/PersistentStore';
import { MailHelper } from '../../utils/MailHelper';
import { LayoutType } from '../../constants/LayoutConstants';
import { UrlHelper } from '../../utils/UrlHelper';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { LongButton } from '../LongButton';
import { CustomLoginActions } from '../../actions/CustomLoginActions';
// import { PRODUCT_NAME } from '../../App';

interface CustomLoginTabState {
    mailLink: string;
}
export class CustomLoginTab extends BaseHamburgerTab<CustomLoginTabState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (AppConfigurationStore.getState().inApp) {
            return (
                <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                    <div className="long-button-group">
                        {this.internalLogin()}
                        {this.externalLogin()}
                    </div>
                </HamburgerContentWrapper>
            );
        }
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                {this.internalLogin()}
                {this.externalLogin()}
            </HamburgerContentWrapper>
        );
    }

    protected onChange = (): void => {
        this.setState({ mailLink: MailHelper.getMailLink() });
    };

    protected getLabel(): string {
        return t('Login');
    }

    protected internalLogin: () => JSX.Element = () => {
        if (AppConfigurationStore.getState().inApp) {
            return (
                <LongButton
                    className="short-border with-arrow with-icon user-button"
                    onClick={CustomLoginActions.login}
                >
                    {t('Login employees')}
                </LongButton>
            );
        }
        return (
            <div
                className="big-button-container"
                // onClick={this.openLink}
                onClick={CustomLoginActions.login}
            >
                <div className="big-button login-button" />
                <div className="big-button-text">{t('Login employees')}</div>
            </div>
        );
    };

    protected externalLogin: () => JSX.Element = () => {
        if (AppConfigurationStore.getState().inApp) {
            return (
                <LongButton
                    className="short-border with-arrow with-icon user-button"
                    onClick={CustomLoginActions.loginExternal}
                >
                    {t('Login partners')}
                </LongButton>
            );
        }
        return (
            <div
                className="big-button-container"
                // onClick={this.openLink}
                onClick={CustomLoginActions.loginExternal}
            >
                <div className="big-button login-button" />
                <div className="big-button-text">{t('Login partners')}</div>
            </div>
        );
    };

    protected openLink = (): void => {
        const width: string = this.props.layoutType === LayoutType.DESKTOP ? '1025' : '800';
        window.open(
            UrlHelper.getExternalHelpLink(this.props.userLanguage),
            'Popup',
            `location=1,status=1,scrollbars=1, resizable=1, directories=1, toolbar=1, titlebar=1, width=${width}, height=800`
        );
    };

    /**
     * Will not work in app till its fixed there
     */
    protected openMail = (): void => {
        if (ViewSettingsStore.getBrowser() === 'Safari') {
            window.location.href = this.state.mailLink;
        } else {
            ViewSettingsActions.showMessage({
                wrap: false,
                element: <iframe style={{display: 'none'}} key={Date.now()} src={this.state.mailLink} width="1" height="1" frameBorder="0"/>,
                type: MessageBoxType.DEFAULT
            });
        }
    };

    protected openProductOverview = (): void => {
        ViewSettingsActions.changeHamburger(HamburgerTab.HELP_PRODUCT_OVERVIEW);
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/CustomLoginTab.tsx